import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

// components
import { Button, Card, CardBody, CardHeader, FormGroup, Form, Input, Row, Col, Spinner } from "reactstrap";
import Select from 'react-select'

// helpers
import { showMessage } from "../../../helpers/message.js";
import { InputCEP, InputCNPJ, InputTELEFONE } from "../../../helpers/mask.js";

// api
import concessionaria_api from "../../../api/concessionaria_api.js";
import regional_api from "../../../api/regional_api.js";
import usuario_api from "../../../api/usuario_api.js";
import cep_api from '../../../api/cep_api.js';

export default function ConcessionariaFicha({ item, handleReturn }) {

    const { register, errors, handleSubmit, setValue, clearErrors } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = useState(false);
    const [showLoadingRegionais, setshowLoadingRegionais] = useState(false);
    const [isDisable, set_isDisable] = useState(true);

    // Status
    const options_status = [
        { label: "Ativo", value: "Ativo" },
        { label: "Inativo", value: "Inativo" }
    ];
    const [status, set_status] = useState(null);
    const handleChangeStatus = (value) => {
        set_status(value);
        clearErrors("status");
        setValue("status", value, true);
    }

    // Regionais
    const [options_regionais, set_options_regionais] = useState([]);
    const loadOptionsRegionais = () => {
        setshowLoadingRegionais(true);
        regional_api.getAllWithoutGeoJson(item?.concessionaria_Id).then(result => {
            setshowLoadingRegionais(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_options_regionais(result.data);
            }
        })
    }

    const [regionais, set_regionais] = useState([]);
    const handleChangeRegionais = (value) => {
        let _regionais = [];
        value.map(m => {
            _regionais.push({
                regional_Id: m.regional_Id,
                concessionaria_Id: item != null ? item?.concessionaria_Id : 0,
                concessionariaRegional_Id: item != null ? item.concessionariaRegionais.filter(f => f.regional_Id == m.regional_Id)[0]?.concessionariaRegional_Id : 0
            });
        })
        set_regionais(_regionais);
    }

    const Voltar = () => {
        handleReturn();
    }

    useEffect(() => {
        usuario_api.getFuncionalidadeAcaoLiberada("CadastroConcessionaria", "Editar").then((result) => { set_isDisable(!result); });
        loadOptionsRegionais();
        loadForm();
    }, []);

    const loadForm = () => {
        if (item != null) {
            setValue("cnpj", item.cnpj);
            setValue("identificacao", item.identificacao);
            set_status(item.status);
            setValue("status", item.status, true);
            set_regionais(item.concessionariaRegionais);
            setValue("IE", item.ie);
            setValue("razao", item.razao);
            setValue("ramoAtividade", item.ramoAtividade);
            setValue("responsavel", item.responsavel);
            setValue("email", item.email);
            setValue("telefone", item.telefone);
            setValue("cep", item.cep);
            setValue("cidade", item.cidade);
            setValue("logradouro", item.logradouro);
            setValue("bairro", item.bairro);
            setValue("numero", item.numero);
        }
    }

    //Função para enviar os dados
    const onSubmit = (data) => {
        let json_submit = {
            concessionaria_Id: item != null ? item?.concessionaria_Id : 0,
            cnpj: data.cnpj.replace(/[^\d]/g, ''),
            identificacao: data.identificacao,
            IE: data.IE,
            razao: data.razao,
            ramoAtividade: data.ramoAtividade,
            responsavel: data.responsavel,
            email: data.email,
            cidade: data.cidade,
            telefone: data.telefone.replace(/[^\d]/g, ''),
            cep: data.cep.replace(/[^\d]/g, ''),
            logradouro: data.logradouro,
            bairro: data.bairro,
            numero: data.numero,
            status: status,
            concessionariaRegionais: regionais
        };

        setshowLoading(true);
        if (json_submit?.concessionaria_Id == 0)
            concessionaria_api.post(json_submit).then(result => handleReturnSubmit(result));
        else
            concessionaria_api.put(json_submit).then(result => handleReturnSubmit(result));
    }

    const handleReturnSubmit = (result) => {
        setshowLoading(false);
        if (result.status !== 200) {
            showMessage("Aviso", result.message, 'error', null);
        }
        else {
            showMessage("Aviso", "Operação executada com sucesso!", 'success', handleReturn);
        }
    }

    //Função para carregar os campos do cep
    const handleCEP = (event) => {
        clearErrors("cep");

        if (event.target.value.length != 9)
            return;

        cep_api.get(event.target.value).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", "Cep não localizado", 'warning', null);
                setValue("logradouro", "");
                setValue("bairro", "");
                setValue("cidade", "");
            }
            else {
                setValue("logradouro", result.data.logradouro);
                setValue("bairro", result.data.bairro);
                setValue("cidade", result.data.localidade);
            }
        });
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div className="content">
                <Row>
                    <Col md="12">
                        <Button color="default" onClick={Voltar}>
                            <i className="fas fa-chevron-left"></i>  Voltar
                        </Button>
                    </Col>
                </Row>
                <Card>
                    <CardHeader>
                        <h4 className="titleCard">Concessionária</h4>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <Row className="align-items-end">
                                <Col lg="4" md="12" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">CNPJ</label>
                                        <InputCNPJ className="form-control"
                                            autocomplete="off"
                                            defaultValue={item != null ? item.cnpj : ""}
                                            type="text"
                                            name="cnpj"
                                            inputRef={register({ required: true })}
                                            disabled={isDisable}
                                        />
                                        {errors.cnpj && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="8" md="12" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Identificação</label>
                                        <Input className="form-control"
                                            autocomplete="off"
                                            type="text"
                                            name="identificacao"
                                            innerRef={register({ required: true })}
                                            disabled={isDisable}
                                        />
                                        {errors.identificacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="4" md="12" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">IE</label>
                                        <Input className="form-control"
                                            autocomplete="off"
                                            type="text"
                                            name="IE"
                                            innerRef={register({ required: true })}
                                            disabled={isDisable}
                                        />
                                        {errors.IE && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="8" md="12" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Razão Social</label>
                                        <Input className="form-control"
                                            autocomplete="off"
                                            type="text"
                                            name="razao"
                                            innerRef={register({ required: true })}
                                            disabled={isDisable}
                                        />
                                        {errors.razao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="4" md="12" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Ramo de atividade</label>
                                        <Input className="form-control"
                                            autocomplete="off"
                                            type="text"
                                            name="ramoAtividade"
                                            innerRef={register({ required: true })}
                                            disabled={isDisable}
                                        />
                                        {errors.ramoAtividade && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="4" md="12" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Responsavel</label>
                                        <Input className="form-control"
                                            autocomplete="off"
                                            type="text"
                                            name="responsavel"
                                            innerRef={register({ required: true })}
                                            disabled={isDisable}
                                        />
                                        {errors.responsavel && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="4" md="12" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">E-mail</label>
                                        <Input className="form-control"
                                            autocomplete="off"
                                            type="text"
                                            name="email"
                                            innerRef={register({ required: true })}
                                            disabled={isDisable}
                                        />
                                        {errors.email && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="4" md="12" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Telefone</label>
                                        <InputTELEFONE
                                            className="form-control"
                                            autocomplete="off"
                                            defaultValue={item != null ? item.telefone : ""}
                                            type="text"
                                            name="telefone"
                                            inputRef={register({ required: true })}
                                            disabled={isDisable}
                                        />
                                        {errors.telefone && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="4" md="12" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Cep</label>
                                        <InputCEP
                                            className="form-control"
                                            autocomplete="off"
                                            defaultValue={item != null ? item.cep : ""}
                                            type="text"
                                            name="cep"
                                            inputRef={register({ required: true })}
                                            onBlur={handleCEP}
                                            disabled={isDisable}
                                        />
                                        {errors.cep && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="4" md="12" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Cidade</label>
                                        <Input className="form-control"
                                            autocomplete="off"
                                            type="text"
                                            name="cidade"
                                            innerRef={register({ required: true })}
                                            disabled={isDisable}
                                        />
                                        {errors.cidade && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="9" md="12" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Logradouro</label>
                                        <Input className="form-control"
                                            autocomplete="off"
                                            type="text"
                                            name="logradouro"
                                            innerRef={register({ required: true })}
                                            disabled={isDisable}
                                        />
                                        {errors.logradouro && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="3" md="12" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Número</label>
                                        <Input className="form-control"
                                            autocomplete="off"
                                            type="text"
                                            name="numero"
                                            innerRef={register({ required: true })}
                                            disabled={isDisable}
                                        />
                                        {errors.numero && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="9" md="12" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Bairro</label>
                                        <Input className="form-control"
                                            autocomplete="off"
                                            type="text"
                                            name="bairro"
                                            innerRef={register({ required: true })}
                                            disabled={isDisable}
                                        />
                                        {errors.bairro && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>


                                <Col lg="3" md="6" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Status</label>
                                        <Select
                                            name="status"
                                            options={options_status}
                                            getOptionLabel={o => o.label}
                                            getOptionValue={o => o.value}
                                            value={options_status.filter(f => f.value == status)}
                                            onChange={(o) => handleChangeStatus(o.value)}
                                            classNamePrefix="select"
                                            placeholder="[ Selecione ]"
                                            ref={e => register(
                                                { name: "status" },
                                                { required: true })
                                            }
                                            isDisabled={isDisable}
                                        />
                                        {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="12" md="6" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Lista de regionais</label>
                                        <Select
                                            name="regionais"
                                            options={options_regionais}
                                            getOptionLabel={o => o.identificacao}
                                            getOptionValue={o => o.regional_Id}
                                            value={options_regionais.filter(({ regional_Id }) => regionais.filter(f => f.regional_Id == regional_Id).length > 0)}
                                            onChange={(o) => handleChangeRegionais(o)}
                                            classNamePrefix="select"
                                            placeholder="[ Selecione ]"
                                            isMulti={true}
                                            isLoading={showLoadingRegionais}
                                            ref={e => register(
                                                { name: "regionais" },
                                                { required: false })
                                            }
                                            isDisabled={isDisable}
                                        />
                                        {errors.regionais && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                            </Row>
                            {!isDisable &&
                                <Row>
                                    <Col lg="12" md="12" sm="12" className="text-center">
                                        <Button color="success" type="submit">
                                            <i className="fas fa-save"></i>  Salvar
                                        </Button>
                                    </Col>
                                </Row>
                            }
                        </Form>
                    </CardBody>
                </Card>
            </div>
        </>
    );
}

